import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import { PiBuildingOfficeBold, PiStudent } from "react-icons/pi";
import { formatMoney, formatMoneyShorten } from "../Helpers";
import { FaChalkboardTeacher } from "react-icons/fa";
import { SiGoogleclassroom } from "react-icons/si";
import { IoIosPeople } from "react-icons/io";
import { getInlineLoader } from "../Helpers";
import HomeBanner1 from "../ones/HomeBanner1";

import Footer from "../ones/Footer";
import banner1 from '../assets/banner1.jpg';
import banner2 from '../assets/banner2.jpg';
import banner3 from '../assets/banner3.jpg';
import banner4 from '../assets/banner4.jpg';
import banner5 from '../assets/banner5.jpg';
import banner6 from '../assets/banner6.jpg';
import banner7 from '../assets/banner7.jpg';

import medical_pic from '../assets/photos/medical_equipments/18.jpg';
import promo_pic from '../assets/photos/promotional_materials/12.jpg';
import education_pic from '../assets/photos/educational_solutions/1.jpg';
import moble_pic from '../assets/photos/smart_mobile/2.jpg';
import realestate_pic from '../assets/photos/real_estate/3.jpg';
import telecom_pic from '../assets/photos/telecom_solutions/6.jpg';
import ict_pic from '../assets/photos/ict_solutions/1.jpg';
import agri_pic from '../assets/photos/agricultular_solutions/6.jpg';
import energ_pic from '../assets/photos/energy_solutions/1.jpg';
import green_pic from '../assets/photos/energy_solutions/3.jpg';

import br1 from '../assets/photos/promotional_materials/1.jpg';
import br2 from '../assets/photos/promotional_materials/2.jpg';
import br3 from '../assets/photos/promotional_materials/3.jpg';
import br4 from '../assets/photos/promotional_materials/4.jpg';
import br5 from '../assets/photos/promotional_materials/5.jpg';
import br6 from '../assets/photos/promotional_materials/6.jpg';
import br7 from '../assets/photos/promotional_materials/7.jpg';
import br8 from '../assets/photos/promotional_materials/8.jpg';
import br9 from '../assets/photos/promotional_materials/9.jpg';
import br10 from '../assets/photos/promotional_materials/10.jpg';
import br11 from '../assets/photos/promotional_materials/11.jpg';
import br12 from '../assets/photos/promotional_materials/12.jpg';
import br13 from '../assets/photos/promotional_materials/13.jpg';
import br14 from '../assets/photos/promotional_materials/14.jpg';
import br15 from '../assets/photos/promotional_materials/15.jpg';
import br16 from '../assets/photos/promotional_materials/16.jpg';
import br17 from '../assets/photos/promotional_materials/17.jpg';


import { IoMdCheckmarkCircleOutline } from "react-icons/io";
import { FaArrowCircleRight } from "react-icons/fa";
import HorizontalImageStrip from "../ones/HorizontalImagesStrip";

export default function View(props) {

	const appContext = useContext(AppContext);

	/* Place states here */
	const [ ready, setReady ] = useState(false);
	const [ bgIndex, setBgIndex ] = useState(0);
	const banners = [banner5, banner7, banner1, banner2, banner3, banner4, ];

	async function init() {
		//run initializations here
		setReady(false);
		//..
		
		setReady(true);
	}

	useEffect(() => {
		init();
	}, [ ])

	// Background transition effect
	useEffect(() => {
		if (!ready) return;

		const interval = setInterval(() => {
			setBgIndex(prev => (prev + 1) % banners.length);
		}, 2500); // change every 5 seconds

		return () => clearInterval(interval);
	}, [ready]);

	if(ready) {
		return (
			<>
				<div className="MainBodySection">
					<div
						style={{
							width: "100%",
							height: "auto",
							position: "relative",
							overflow: "hidden"
						}}
					>
						{banners.map((banner, i) => (
							<div
								key={i}
								style={{
									backgroundImage: `url(${banner})`,
									backgroundAttachment: "fixed",
									backgroundSize: "cover",
									backgroundPosition: "center",
									width: "100%",
									height: "100%",
									position: "absolute",
									top: 0,
									left: 0,
									transition: "opacity 1.5s ease-in-out",
									opacity: i === bgIndex ? 1 : 0,
								}}
							/>
						))}
	
						{/* gradient overlay */}
						<div
							style={{
								width: "100%",
								height: "100%",
								background: "linear-gradient(to right, rgba(0,0,0,0.9) 0%, rgba(0,0,0,0.4) 80%, rgba(0,0,0,0) 100%)",
								position: "relative",
								zIndex: 1
							}}
						>
							<div className="container">
								<div className="row">
									<div className="col-md-6">
										<h1
											className="font-bold text-light"
											style={{
												fontSize: "28px",
												paddingTop: "40px",
												paddingBottom: "40px",
												textTransform: "uppercase",
											}}
										>
											PROMOTIONAL MATERIAL SOLUTIONS
										</h1>
	
										
	
									</div>
	
									
	
								</div>
							</div>
						</div>
	
					</div>
				</div>
				
				<div 
					className="MainBodySection"
					style={{
						paddingBottom: "50px",
						paddingTop: "50px"
					}}
				>
					<div className="container">
						<div className="row">

							<div className="col-md-12">
								<img
									src={promo_pic}
									style={{
										width: "100%"
									}}
								/>
								<h6
									style={{
										fontSize: "18px",
										marginTop: "20px",
										marginBottom: "20px",
									}}
								>
									JIEZHI TECH CO LTD is your trusted partner in delivering exceptional promotional materials that elevate your brand and enhance your marketing efforts. We understand the importance of high-quality, impactful promotional items in driving brand awareness, customer engagement, and business growth. Our commitment to excellence is reflected in our comprehensive range of promotional material solutions, which includes:
								</h6>

								<HorizontalImageStrip
									images={[br1, br2, br3]}
								/>
							</div>

							<div className="col-md-6 mt-3 mb-4">
								<h6
									className="main-section-title"
								>
									CUSTOM BRANDED MERCHANDISE
								</h6>

								<img
									style={{
										width: "100%",
										height: "auto",
										display: "block",
									}}
									src={br3}
								/>		

								<h6
									style={{
										fontSize: "16px",
										borderLeft: "10px solid var(--primaryColor)",
										paddingLeft: "10px"
									}}
								>
									We offer a wide selection of customizable branded merchandise, such as apparel, bags, drinkware, and stationery, allowing you to showcase your brand with style and functionality.
								</h6>
							</div>

							<div className="col-md-6 mt-3 mb-4">
								<h6
									className="main-section-title"
								>
									PRINT MATERIALS
								</h6>

								<img
									style={{
										width: "100%",
										height: "auto",
										display: "block",
									}}
									src={br10}
								/>		

								<h6
									style={{
										fontSize: "16px",
										borderLeft: "10px solid var(--primaryColor)",
										paddingLeft: "10px"
									}}
								>
									Our high-quality print materials, including brochures, flyers, posters, and business cards, help you effectively communicate your brand message and leave a lasting impression on your target audience.
								</h6>
							</div>

							<div className="col-md-6 mt-3 mb-4">
								<h6
									className="main-section-title"
								>
									TRADE SHOW DISPLAYS
								</h6>

								<img
									style={{
										width: "100%",
										height: "auto",
										display: "block",
									}}
									src={br1}
								/>		

								<h6
									style={{
										fontSize: "16px",
										borderLeft: "10px solid var(--primaryColor)",
										paddingLeft: "10px"
									}}
								>
									We provide eye-catching trade show displays, banners and booth designs that captivate attendees and create a memorable brand experience at events and exhibitions.
								</h6>
							</div>

							<div className="col-md-6 mt-3 mb-4">
								<h6
									className="main-section-title"
								>
									PROMOTIONAL GIFTS
								</h6>

								<img
									style={{
										width: "100%",
										height: "auto",
										display: "block",
									}}
									src={br13}
								/>		

								<h6
									style={{
										fontSize: "16px",
										borderLeft: "10px solid var(--primaryColor)",
										paddingLeft: "10px"
									}}
								>
									Our carefully curated selection of promotional gifts, ranging from tech gadgets to eco-friendly products, allows you to express your appreciation and strengthen relationships with clients, employees, and partners.
								</h6>
							</div>

							<div className="col-md-6 mt-3 mb-4">
								<h6
									className="main-section-title"
								>
									PACKAGING SOLUTIONS
								</h6>

								<img
									style={{
										width: "100%",
										height: "auto",
										display: "block",
									}}
									src={br7}
								/>		

								<h6
									style={{
										fontSize: "16px",
										borderLeft: "10px solid var(--primaryColor)",
										paddingLeft: "10px"
									}}
								>
									We offer innovative and customizable packaging solutions that not only protect your products but also serve as a powerful brand tool, enhancing the unboxing experience for your customers.
								</h6>
							</div>

							
	
						</div>
					</div>
				</div>

				<Footer/>
			</>
		)
	} else {
		return (
			<div 
				className="container mSupportLoading"
			>
				{getInlineLoader()}
			</div>
		);
	}

	
}